import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FabBadgeComponent } from './components/fab-badge/fab-badge.component';
import { FabOutletComponent } from './components/fab-outlet/fab-outlet.component';
import { FabService } from './services/fab.service';
import { MediaModule } from '../media/media.module';

@NgModule({
    declarations: [FabOutletComponent, FabBadgeComponent],
    exports: [FabOutletComponent],
    imports: [
        CommonModule,
        MediaModule
    ],
    providers: [FabService]
})
export class FabModule { }
